import BlockyHeavyText from "components/custom-texts/blocky-heavy-text";
import { ToggleButton } from "react-bootstrap";

const RankSelector = ({
  numberOfSelections,
  contestantId,
  onSelectContestantId,
  selectedContestantIds,
  winnerRank,
  isOpenPool
}: any) => {
  const ranks = Array.apply(null, Array(numberOfSelections)).map(function (
    x,
    i
  ) {
    return i + 1;
  });
  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "space-evenly",
      }}
      defaultValue={undefined}
      id={contestantId}
    >
      {ranks.map((rank, index) => {
        const value = `${rank}_${contestantId}`;
        const checked = selectedContestantIds[rank - 1] === contestantId;

        const uniqueIdentifier = `${contestantId}_${index}_${numberOfSelections}`;
        let color = "lightgray";
        if (rank === winnerRank) {
          color = "var(--winner-green)";
        }

        return (
          <div
            key={index}
            style={
              !isOpenPool
                ? {
                    backgroundColor: color,
                    borderRadius: 100,
                    color: "black",
                    border: "1px solid black",
                  }
                : {}
            }
          >
            <ToggleButton
              key={uniqueIdentifier}
              id={uniqueIdentifier}
              type="checkbox"
              name={uniqueIdentifier}
              style={{
                borderRadius: "100%",
                height: 38,
                width: 38,
                boxShadow: "none",
              }}
              variant="outline-success"
              value={value}
              checked={checked}
              disabled={!isOpenPool}
              onChange={(e) => {
                if (checked) {
                  // item being clicked is selected so we want to unselect
                  onSelectContestantId(undefined, rank);
                } else {
                  onSelectContestantId(contestantId, rank);
                }
              }}
            >
              <BlockyHeavyText style={{ color: "black" }}>
                {rank}
              </BlockyHeavyText>
            </ToggleButton>
          </div>
        );
      })}
    </div>
  );
};

export default RankSelector;
